import { render, staticRenderFns } from "./UserReferralProgram.vue?vue&type=template&id=42c6b018&scoped=true&"
import script from "./UserReferralProgram.vue?vue&type=script&lang=js&"
export * from "./UserReferralProgram.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralProgram.vue?vue&type=style&index=0&id=42c6b018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6b018",
  null
  
)

export default component.exports